import React from 'react';
import { faExclamationCircle, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoldSmallBodyText, Header5Text, SmallBodyText, SpacerRow, Tooltip } from 'ui-toolkit';
import styled from 'styled-components';

export interface IActualBalanceLabelProps {}

const BoldSmallBodyTextSpan = styled.span`
  ${(props) => props.theme.fonts.mixins.boldSmall}
`;

export const ActualBalanceMoneyLabel: React.FC<IActualBalanceLabelProps> = () => {
  return (
    <Tooltip
      placement={'bottom'}
      tooltipContent={
        <>
          <BoldSmallBodyText>What is this?</BoldSmallBodyText>
          <SmallBodyText>
            This represents the current actual balance tied to this order that Spruce is holding in escrow.
          </SmallBodyText>
          <SpacerRow />
          <BoldSmallBodyText>How is it calculated?</BoldSmallBodyText>
          <SmallBodyText>
            This is the sum of all transactions matched to this order less{' '}
            <BoldSmallBodyTextSpan>cleared</BoldSmallBodyTextSpan> disbursements.
          </SmallBodyText>
          <SpacerRow />
          <SmallBodyText>
            <FontAwesomeIcon icon={faExclamationCircle} /> For incoming funds to show as a part of this balance, they
            *must* be matched to the transaction.
          </SmallBodyText>
        </>
      }
    >
      <div className={'flex flex-row gap-1 items-center'}>
        <Header5Text>Actual</Header5Text>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    </Tooltip>
  );
};
